import { OrderBulkDto } from '@tiendanube/common';
import { Status as StatusEnum } from '@tiendanube/common/src/enums';
import { NE_PRINT_LABEL_LIMIT_TEMP } from 'domains/NuvemEnvioCommons/constants';

export interface OrderForPrintLabel {
  orderId: string;
  fulfillmentId: string;
  paymentStatus: StatusEnum;
}

export const transformBulkOrdersToOrdersForPrintLabel = (
  selectedRowsId: string[],
  bulkOrders: OrderBulkDto[],
): OrderForPrintLabel[] =>
  bulkOrders
    .filter((order) => selectedRowsId.includes(order.orderId))
    .flatMap((order) =>
      order.fulfillments.map((fulfillment) => ({
        orderId: order.orderId,
        fulfillmentId: fulfillment.fulfillmentId,
        paymentStatus: order.paymentStatus as StatusEnum,
      })),
    );

export const extractFulfillmentOrdersIds = (
  orders: OrderForPrintLabel[],
): string[] =>
  orders
    .filter((order) => order.paymentStatus === StatusEnum.PAID)
    .map((order) => order.fulfillmentId)
    .slice(0, NE_PRINT_LABEL_LIMIT_TEMP);
